import { login } from '@/api/user'
import { getCookie, setCookie, removeCookie } from '@/utils/auth' // cookie保存
import { resetRouter } from '@/router'
import md5 from 'js-md5';

const getDefaultState = () => {
  return {
    name: '',
  }
}

const state = getDefaultState()

const mutations = {
  // 重置state
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  // 用户名
  SET_USER_NAME: (state, name) => {
    state.name = name
  },
}

const actions = {
  // user login
  login ({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      // trim()去除字符串的头尾空格
      login({ account: username.trim(), password: password }).then(response => {
        // state
        // commit('SET_USER_NAME', response.name)
        // cookie
        setCookie(response)

        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout ({ commit, state }) {
    // 清空token
    removeCookie() // must remove  token  first
    commit('RESET_STATE')
    // 重置路由
    resetRouter()
  },
  // get user info
  getInfo ({ commit, state }) {
    commit('SET_USER_NAME', getCookie('name'))
    return state.name
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      removeCookie() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

